const ProductCategory = ["Door Phone","Indoor Monitor","IP Video Phone","IP Phone","Mobile Application","Training Kit"];
let productCategoryList = [];
for(let i in ProductCategory)
    productCategoryList.push({ID:i,Name:ProductCategory[i]});

const ProductModel7 = ["X916","R29","R28","R27","R26B","R26","R23","E21","R20K","R20A",
    "E11","IT83","IT82","C317","C315","C313","C312","R48G","SP-R67G","SP-R63G",
    "SP-R55G","SP-R59P","SP-R52P","SP-R50P","R15P","EM63","EM53","EA40","SmartPlus","Vfone",
    "Training Kit - 001"];
let productModel7List = [];
for(let i in ProductModel7)
    productModel7List.push({ID:i,Name:ProductModel7[i]});

const DocumentType = ["CE","FCC","Protection - Certification","Certification","Datasheet","User Manual","Quick Guide","Cutsheet"];

let documentTypeList = [];
for(let i in DocumentType)
    documentTypeList.push({ID:i,Name:DocumentType[i]});

const Certification = [{9:"CE"},{1:"FCC"},{2:"Protection - Certification"}];

let certificationList = [];
certificationList.push({ID:9,Name:"CE"});
certificationList.push({ID:1,Name:"FCC"});
certificationList.push({ID:2,Name:"Protection - Certification"});
export { ProductCategory,productCategoryList,ProductModel7,productModel7List,DocumentType,documentTypeList,Certification,certificationList };

